var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareOfVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3254 44.9752L59.6752 52.325L59.6753 52.3253C61.7755 54.4251 61.7755 57.5753 59.675 59.6751C57.5751 61.775 54.4249 61.775 52.3251 59.6751L44.9752 52.3253C41.3001 54.6877 37.1 56.0002 32.3752 56.0002C19.2501 56.0002 8.75 45.5002 8.75 32.3751C8.75 19.25 19.2501 8.74963 32.3752 8.75C45.5002 8.75 56.0003 19.25 56.0003 32.3751C56.0003 37.1001 54.6878 41.3002 52.3254 44.9752ZM32.3751 13.9998C22.1376 13.9998 13.9999 22.1374 13.9999 32.3749C13.9999 42.6124 22.1376 50.75 32.3751 50.75C42.6125 50.75 50.7502 42.6124 50.7502 32.3749C50.7502 22.1375 42.6125 13.9998 32.3751 13.9998ZM24.5 24.4997H19.25V40.2498H24.5V24.4997ZM29.75 19.25H35V40.2501H29.75V19.25ZM45.5001 24.4997H40.25V40.2498H45.5001V24.4997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOfVolume);
export default __webpack_public_path__ + "static/media/ShareOfVolume.fe68a65a190da91ad6af6a562f4ff6cd.svg";
export { ForwardRef as ReactComponent };